import React, {useState} from 'react';
import {Redirect} from 'react-router-dom';

const GroupForm = ({api}) => {

    const [groupName, setGroupName] = useState("");
    const [groupDomain, setGroupDomain] = useState("");
    const [formError, setFormError] = useState("");
    const [formDone, setFormDone] = useState(false);

    const createGroup = async(evt) => {
        evt.preventDefault();
        setFormError('');
        let result = await api.createGroup(groupName, groupDomain).catch(err => {
            setFormError(err.message);
        });
        console.log(result);
        if(!!result) {
            setFormDone(true);
        }
    }

    const groupNameChange = (evt) => {
        setGroupName(evt.target.value);
    }

    const groupDomainChange = (evt) => {
        setGroupDomain(evt.target.value);
    }

    if(formDone) {
        return <Redirect to="/groups"></Redirect>
    }

    return <form className="LoginForm" onSubmit={createGroup}>
        <div className="form-group">
            <label htmlFor="name">Group Name</label>
            <input type="text" className="form-control" required id="name" value={groupName} onChange={groupNameChange} />
        </div>
        <div className="form-group">
            <label htmlFor="domain">Domain</label>
            <input type="text" className="form-control" required id="domain" placeholder="Domain to map users (heanet.ie => user@heanet.ie)" value={groupDomain} onChange={groupDomainChange} />
        </div>
        <span className="text-danger">{formError}</span>
        <button type="submit" className="btn btn-primary float-right">Submit</button>
    </form>
}

export default GroupForm;